export default __webpack_public_path__ + "static/media/pol2d.e155b7d9.svg";